import Swal from "sweetalert2"

export const farmerStatus = () => JSON.parse(localStorage?.getItem("profile"))?.status

export const unauthorizedAlert = ({ navigate }) => {
    if (JSON.parse(localStorage?.getItem("profile"))?.status === "DRAFT") {
        Swal.fire({
            title: "خطای عدم احراز هویت",
            text: "برای استفاده از این بخش ابتدا باید ثبت نام کنید",
            icon: "error",
            showCloseButton: true,
            showConfirmButton: true,
            confirmButtonText: 'ثبت نام'
        }
        ).then(result => {
            if (result.isConfirmed) {
                navigate("/profile")
            }
        })
    }
}